import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';
import sellerStatisticService from '../../../services/seller/statistics';
import moment from 'moment';

const initialState = {
  loading: false,
  topProducts: [],
  error: '',
  params: {
    time: 'subMonth',
    perPage: 5,
  },
};

// Helper function to build API params with proper priority
const buildApiParams = (params = {}) => {
  const apiParams = { ...params };
  
  // If date_from is provided, use date range and remove time
  if (apiParams.date_from) {
    apiParams.date_to = apiParams.date_to || moment().format('YYYY-MM-DD');
    delete apiParams.time;
  } else if (!apiParams.time) {
    // Default to subMonth if neither date_from nor time is provided
    apiParams.time = 'subMonth';
  }
  
  return apiParams;
};

export const fetchTopProducts = createAsyncThunk(
  'statistics/fetchTopProducts',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return statisticService.topProducts(apiParams).then((res) => res);
  },
);
export const fetchSellerTopProducts = createAsyncThunk(
  'statistics/fetchSellerTopProducts',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return sellerStatisticService.topProducts(apiParams).then((res) => res);
  },
);

const topProductSlice = createSlice({
  name: 'topProducts',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTopProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopProducts.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.topProducts = payload.data;
      state.error = '';
    });
    builder.addCase(fetchTopProducts.rejected, (state, action) => {
      state.loading = false;
      state.topProducts = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchSellerTopProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerTopProducts.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.topProducts = payload.data;
      state.error = '';
    });
    builder.addCase(fetchSellerTopProducts.rejected, (state, action) => {
      state.loading = false;
      state.topProducts = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterTopProducts(state, action) {
      const { payload } = action;
      state.params = payload;
    },
  },
});
export const { filterTopProducts } = topProductSlice.actions;
export default topProductSlice.reducer;
